module.exports = __webpack_public_path__ + "static/media/en.0e278278.svg";